<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Access Approval</h4>
    <fh-refresh-button [refresh]="refreshData" />
  </div>

  <fh-filter-bar [showResetButton]="false">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search</mat-label>
      <input
        matInput
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)"
        (keyup.enter)="onSearchChange(searchText())"
        placeholder="Search by name, email, ID..."
      />
      <button matSuffix mat-icon-button (click)="onSearchChange(searchText())">
        <mat-icon>search</mat-icon>
      </button>
      @if (searchText()) {
        <button
          matSuffix
          mat-icon-button
          (click)="searchText.set(''); onSearchChange('')"
          class="clear-button"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="reset-inline">
      <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  </fh-filter-bar>

  <p class="hint">
    Accounts that self-signed-up (or were promoted) as admin or vendor but haven't been activated
    yet. Activating sends the account an email so they know they can now log in.
  </p>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
